"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _baseActions = _interopRequireDefault(require("./base-actions"));
var _index = _interopRequireDefault(require("../../other/lead-gen-form-modal/index.js"));
var _index2 = _interopRequireDefault(require("../../other/intent-modal/index.js"));
function ActionsWithModals({
  actionsTemplateMap = {},
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(_baseActions.default, (0, _extends2.default)({
    actionsTemplateMap: {
      RacModal: _index.default,
      LeadGenFormModal: _index.default,
      IntentModal: _index2.default,
      ...actionsTemplateMap
    }
  }, rest));
}
ActionsWithModals.propTypes = _baseActions.default.propTypes;
var _default = exports.default = ActionsWithModals;